import React, { Component } from 'react';
import ReactDOM from 'react-dom';

// constants
import { MAGNITT_ACCESS_ROLES } from '/src/lib/constants/userRoles';
import { HUBSPOT_FORM_SOURCE } from '/src/lib/constants';

// helpers
import AmplitudeHelperClass from '/src/lib/amplitudeHelper';
import * as fundingRowHelpers from '/src/pages/directories/helpers/fundingRowHelpers';
import { withBootstrapPlugin } from '/src/lib/helpers';

// reusable
import { renderLockedEntityName } from '/src/components/LockedContent';



const amplitudeHelper = new AmplitudeHelperClass();

export default class DirTable extends Component {

    constructor(props) {
        super(props);
        this.state = {
            // scroll position
            scrollPos: 1, // shouldn't be 0 at page load
            maxScroll: null,
            showLockedRows: false,
            // for locked content
            scrollFixWidth: 500,
            scrollFixHeight: 200,
        }
    }

    /* lifecycle methods */

    componentDidMount = () => {
        this.renderLocked();

        // initialize scroll width
        window.addEventListener('resize', this.scrollWidthFix);
        if (ReactDOM.findDOMNode(this.refs.scrollTable)) {
            this.setState({ scrollPos: ReactDOM.findDOMNode(this.refs.scrollTable).scrollLeft });
        }

        this.initiateTooltip();
        this.props.setState({ removeSkeletonTable: true });
    }

    componentDidUpdate = () => {
        this.scrollWidthFix();
        this.initiateTooltip();
    }

    /* end lifecycle methods */

    // Initiate tooltip
    initiateTooltip = () => {
        if (typeof window.jQuery !== 'undefined') {
            $(function () {
                if (document.querySelectorAll('[data-toggle="tooltip"]') && $?.fn?.tooltip) {
                    $('[data-toggle="tooltip"]').tooltip();
                }
            })
        }
    }

    // fix scroll issues in locked content and table collapsible row
    scrollWidthFix = () => {

        const { showLockedRows, scrollFixWidth, scrollFixHeight } = this.state;
        const { isFundingView, isExitsView } = this.props;
        const tableIndex = isExitsView ? 2 : (isFundingView ? 1 : 0)

        const element = document.getElementsByClassName("table-responsive");
        if (element && element[tableIndex]) {
            if (scrollFixWidth !== element[tableIndex].clientWidth) {
                this.setState({ scrollFixWidth: element[tableIndex].clientWidth })
            }
        }

        if (showLockedRows) {
            let getHeightInterval = setInterval(() => {
                const element1 = document.querySelectorAll('tbody.paywall-box')
                if (element1 && element1[tableIndex]) {
                    if (scrollFixHeight !== element1[tableIndex].clientHeight) {
                        this.setState({ scrollFixHeight: element1[tableIndex].clientHeight })
                    }
                    clearInterval(getHeightInterval)
                }
                200
            })
        }

    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.scrollWidthFix);
    }

    makeRow = (rowData, lockedView, index) => {
        let row = [];
        const { entityType } = this.props;

        for (var i in rowData) {
            for (var key in rowData[i]) {
                if (key !== "id" && key !== "code" && key !== "element_name") {
                    const data = rowData[i][key];

                    if (data === "paidData") {
                        row.push(
                            <td data-rowtype={key} key={key}>
                                <a className="btn btn-main-outline btn-sm" href="/pricing" target="_blank" rel="noopener noreferrer">
                                    <span className="d-flex align-items-center">
                                        <i className="fas fa-lock"></i><span>Unlock</span>
                                    </span>
                                </a>
                            </td>
                        )
                    } else if (lockedView && (entityType == "STARTUP" || entityType == "INVESTOR") && key == "name") {
                        row.push(
                            <td data-rowtype={key} key={key}>
                                <div className="d-flex align-items-center">
                                    <a className="d-flex align-items-center">
                                        <div className="startupLogo"></div>
                                        <div className="flex-column" style={{ marginLeft: 10, marginTop: -4 }} >
                                            <div className="startup-name" data-action="expand-slider">
                                                {renderLockedEntityName(entityType, index)}
                                            </div>
                                            {entityType == "STARTUP" &&
                                                <div className='messageBtn accordion-toggle'>
                                                    <i className="fas fa-lock" /> {' '}  See Funding
                                                </div>
                                            }
                                        </div>
                                    </a>
                                </div>
                            </td>
                        )
                    } else {
                        row.push(<td data-rowtype={key} key={`${key}-${i}-${index}`}><div>{data || '-'}</div></td>)
                    }
                }
            }
        }
        return row;
    }

    scrollTable = (scrollType) => {
        const scrollVal = 80; // scroll distance
        const element = ReactDOM.findDOMNode(this.refs.scrollTable);
        if (!element) { return }

        const maxScroll = element.scrollWidth - element.clientWidth;
        this.setState({ maxScroll })
        this.setState({ scrollPos: element.scrollLeft })

        if (scrollType === 1) {
            // go left
            element.scrollLeft -= scrollVal;
            this.setState({ scrollPos: (element.scrollLeft - scrollVal) })
        } else if (scrollType === 2) {
            // go right
            element.scrollLeft += scrollVal;
            this.setState({ scrollPos: (element.scrollLeft + scrollVal) })
        }
        // didn't use this.setState({ scrollPos: element.scrollLeft }) - it doesn't reflect the latest scroll
    }

    showContactForm = () => {
        const { setState } = this.props
        const entityType = this.props.entityType.toLowerCase()

        if (entityType === 'startup') {
            setState({ contactSalesPopUpSource: HUBSPOT_FORM_SOURCE.startups_dir_locked_section })
        } else if (entityType === 'investor') {
            setState({ contactSalesPopUpSource: HUBSPOT_FORM_SOURCE.investor_dir_locked_section })
        } else if (entityType === 'funding') {
            setState({ contactSalesPopUpSource: HUBSPOT_FORM_SOURCE.funds_dir_locked_section })
        } else if (entityType === 'exit') {
            setState({ contactSalesPopUpSource: HUBSPOT_FORM_SOURCE.exits_dir_locked_section })
        } else if (entityType === 'private equity') {
            setState({ contactSalesPopUpSource: HUBSPOT_FORM_SOURCE.private_equity_dir_locked_section })
        }

        if (document.getElementById('contactFormModal')) {
            withBootstrapPlugin('modal', ($) => $('#contactFormModal').modal({
                backdrop: 'static', keyboard: true, show: true
            }));
        }
    }

    renderTableRows = () => {

        const { content, showFundingSubRow, state, setState, user } = this.props;
        const rowData = content.rows;
        let userHasDirectoryAccess = false, lockedView = false;
        if (user && user.roles && user.roles.length > 0) {
            userHasDirectoryAccess = (user.roles.includes(MAGNITT_ACCESS_ROLES.directory_access) || user.roles.includes(MAGNITT_ACCESS_ROLES.limited_directory_access))
        }

        const tableRows = rowData.map((row, j) => {
            const tableDataCells = this.makeRow(row, lockedView, j);
            if (showFundingSubRow) {

                const entity_data = row[row.length - 1];
                const tempData = {
                    table_cells: tableDataCells,
                    index: j,
                    entity_data,
                    funding_data: state["funding_rounds_" + entity_data.id],
                    setParentState: setState,
                    userHasDirectoryAccess
                }

                return (fundingRowHelpers.renderFundingSubRows(tempData, j))

            } else {
                return (<tr key={j}>{tableDataCells}</tr>)
            }
        })
        return tableRows;

    }

    renderLockedTableRows = () => {
        const { content, entityType } = this.props;
        const { showLockedRows } = this.state;

        // check locked row data is available
        if (content.rows.length < 1) {
            return;
        }

        // display at least 5 rows for locked content
        // duplicate existing rows if < 5
        let rowData = [...content.rows];
        if (showLockedRows) {
            const lockedRowCount = (entityType === 'FUND' ? 8 : 5);
            while (rowData.length < lockedRowCount) {
                rowData = [...rowData, ...rowData]
            }
            while (rowData.length > lockedRowCount) {
                rowData.splice(lockedRowCount, 1);
            }
        }

        let lockedView = true;
        const tableRows = rowData.map((row, j) => {
            return (<tr key={j}>{this.makeRow(row, lockedView, j)}</tr>)
        })
        return tableRows;
    }

    renderLocked = () => {
        const { user } = this.props;
        let showLockedRows = false;
        if (!user.is_loggedin) {
            showLockedRows = true;
        } else if (!(user.roles.includes(MAGNITT_ACCESS_ROLES.directory_access) || user.roles.includes(MAGNITT_ACCESS_ROLES.limited_directory_access))) {
            showLockedRows = true;
        }
        this.setState({ showLockedRows })
    }

    amplitudeTrack(action) {
        if (action) {
            amplitudeHelper.trackEvent(action);
        } else {
            const { entityType, altTitle } = this.props;
            const entity = (altTitle ? altTitle : entityType.toLowerCase());
            amplitudeHelper.trackEvent(entity + " locked dir - clicked learn more");
        }

    }

    Login(event) {
        if (typeof window !== 'undefined') {
            const headerLogin = document.getElementById('headerLogin');
            if (headerLogin) {
                headerLogin.click();
            }
        }
        const { entityType, altTitle } = this.props;
        const entity = (altTitle ? altTitle : entityType.toLowerCase());
        this.amplitudeTrack(entity + " locked dir - clicked login");
    }

    render() {

        const { content, entityType, user, fullyLocked, altTitle } = this.props;
        const { scrollPos, maxScroll, showLockedRows, scrollFixHeight, scrollFixWidth } = this.state;

        const entity = (altTitle ? altTitle : entityType.toLowerCase());

        // list of  paths that contact sales popup form display
        const pathNames = ['startup', 'funding', 'investor', 'funds']

        const scrollFixStyles = {
            width: scrollFixWidth,
            bottom: 15, // bugfix - prevent locked component from overlaying scrollbar
            height: scrollFixHeight
        }

        return (
            <div className="directory-table">
                <div className="table-responsive" ref="scrollTable">
                    <table className="table">

                        <thead>
                            <tr>
                                {content.header &&
                                    content.header.map((item, i) => {
                                        return (
                                            <th key={i}>
                                                {i === 1 && scrollPos > 0 &&
                                                    <div className="table-scroll" onClick={() => this.scrollTable(i)}></div>
                                                }
                                                {i === 2 && scrollPos <= maxScroll &&
                                                    <div className="table-scroll" onClick={() => this.scrollTable(i)}></div>
                                                }
                                                {item}
                                            </th>
                                        )
                                    })}
                            </tr>
                        </thead>

                        {!fullyLocked &&
                            <tbody>
                                {this.renderTableRows()}
                            </tbody>
                        }

                        {showLockedRows &&
                            <tbody className="paywall-box paywall-box-blurred" style={{ position: 'unset' }}>
                                <tr className="paywall-content paywall-content-absolute" style={scrollFixStyles}>
                                    {!user.is_loggedin ?
                                        pathNames.includes(entity?.toLowerCase()) ? <a onClick={() => { this.amplitudeTrack(entity + " locked dir - clicked contact us"); this.showContactForm() }}>
                                            <span className="paywall-label">
                                                <i className="fas fa-lock"></i>
                                                <h3>Want more?</h3>
                                                <span>Get in touch with us for a full access</span>
                                                <a className="btn btn-main">Contact Us</a>
                                            </span>
                                        </a> : <a onClick={() => this.Login()}>
                                            <span className="paywall-label">
                                                <i className="fas fa-lock"></i>
                                                <h3>Want more data?</h3>
                                                <span>Login to gain access to our {entity} directory</span>
                                                <a className="btn btn-main">Login</a>
                                            </span>
                                        </a>
                                        :
                                        <a onClick={() => { this.amplitudeTrack(); this.showContactForm() }} >
                                            <span className="paywall-label">
                                                <i className="fas fa-lock"></i>
                                                <h3>Want more data?</h3>
                                                <span>To unlock the full functionality of MAGNiTT, upgrade your account with a subscription</span>
                                                <a className="btn btn-main">Learn More</a>
                                            </span>
                                        </a>
                                    }
                                </tr>
                                {this.renderLockedTableRows()}
                            </tbody>
                        }

                    </table>
                </div>
            </div>
        );
    }
}
